export const FitTextGroupKey = Symbol('fit-text-group')

// Lets a set of core-fit-text instances agree on one shared font size — the
// smallest natural fit among them — so a grid of cards scales in lockstep
// instead of each card sizing its text independently.
export const useFitTextGroup = () => {
  const sizes = reactive<Map<symbol, number>>(new Map())
  const minSize = computed(() => sizes.size ? Math.min(...sizes.values()) : 0)

  const register = (fontSize: Readonly<Ref<number>>) => {
    const id = Symbol()
    watch(fontSize, val => sizes.set(id, val), { immediate: true })
    onUnmounted(() => sizes.delete(id))
  }

  return { register, minSize }
}

export type FitTextGroup = ReturnType<typeof useFitTextGroup>
